export const environment = {
  production: true,
  buildId: '3025112078719971',
  configFile: 'config.json',
};
